interface TileImageConfig {
  x: number;
  y: number;
  texture: string;
  frame?: string;
  id: string;
  image: string;
  creator: string;
}
export class TileImage extends Phaser.GameObjects.Image {
  public tileId: string;
  public src: string;
  public creator: string;

  constructor(
    scene: Phaser.Scene,
    { x, y, texture, frame, id, image, creator }: TileImageConfig
  ) {
    super(scene, x, y, texture, frame);
    this.tileId = id;
    this.src = image;
    this.creator = creator;
  }
}
